import * as actions from "./actions";

export default function customQuoteReducer(state = {}, action) {
    switch (action.type) {

    case actions.SET_CUSTOM_QUOTE_SUCCESS:
    case actions.SET_CUSTOM_QUOTE_FAIL:
    case actions.UPDATE_CUSTOM_QUOTE:
    {
        return action.payload;
    }
    case actions.CUSTOM_QUOTE_RESET:
    {
        return {};
    }
    default:
        return state;

    }
}
